import React from "react";
import {Link} from 'react-router-dom';

export default (props) => {

    const {
        publish,
        company,
        isBalance,
        isBalanceText
    } = props;

    if(!publish || isBalance) return false;

    let url = '/account/balance';
    let urlText = 'Пополнить баланс';

    if(company) {
        url = '/account/entity/balance';
        urlText = 'Пополнить баланс компании';
    }

    return (
        <div>
            <div className="not-enought-money">
                {isBalanceText}
            </div>
            <Link to={url}>
                {urlText}
            </Link>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Modals/NotEnoughMoney.js